<vw-toast-popup [isOpen]="isOpen" width="100%" borderRadius="5px" customClass="bg-[#FAFAFA] overflow-auto"
  (close)="onClose()">
  @if (cultivation && cultivationVariant) {
    <vw-cultivation-guide [plant]="plant" [cultivation]="cultivation"
      [cultivationVariant]="cultivationVariant"></vw-cultivation-guide>
  }
</vw-toast-popup>